function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { property as r } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { createRef as u } from "../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { generateRandomId as m } from "../../utils/string-utils.js";
import { TestableLitElement as E } from "../../utils/components/testable-lit-element/testable-lit-element.js";
import { handleDataTestid as p } from "../../utils/datatestid-utils.js";
import { getFirstFocusableElement as y, getFocusableElements as v } from "../../utils/accessibility-utils.js";
var _ = Object.defineProperty,
  n = function n(d, e, t, s) {
    for (var o = void 0, i = d.length - 1, h; i >= 0; i--) (h = d[i]) && (o = h(e, t, o) || o);
    return o && _(e, t, o), o;
  };
var a = /*#__PURE__*/function (_E) {
  function a() {
    var _this;
    _classCallCheck(this, a);
    _this = _callSuper(this, a, arguments), _this.referenceId = "", _this.title = "", _this.xOffset = 0, _this.yOffset = 0, _this.iconName = void 0, _this.errorText = void 0, _this.size = "medium", _this.showOnHover = !1, _this._popoverRef = u(), _this._forceOpen = !1, _this._mousedInsidePopover = !1, _this._placement = "top", _this.popoverId = m(), _this.elementListeners = new WeakMap();
    return _this;
  }
  _inherits(a, _E);
  return _createClass(a, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _e$shadowRoot, _e$shadowRoot2;
      if (this._popoverRef.value && (this._popoverRef.value.style.visibility = "hidden", this._popoverRef.value.style.opacity = "0"), !this.referenceId) return;
      var e = this.referenceElement,
        t = this._popoverRef.value;
      var s;
      (_e$shadowRoot = e.shadowRoot) !== null && _e$shadowRoot !== void 0 && _e$shadowRoot.delegatesFocus ? s = y(e) : s = e, s && (s.ariaDescribedByElements = [this]), e && t && (p(e, this.dataTestid, "trigger"), p(t, this.dataTestid, "popover"), (_e$shadowRoot2 = e.shadowRoot) !== null && _e$shadowRoot2 !== void 0 && (_e$shadowRoot2 = _e$shadowRoot2.firstElementChild) !== null && _e$shadowRoot2 !== void 0 && _e$shadowRoot2.setAttribute("aria-expanded", "false"), this.showOnHover ? this._addShowOnHoverEvents(e, t) : this._addShowOnClickEvents(e, t));
    }
  }, {
    key: "updated",
    value: function updated(e) {
      if (_superPropGet(a, "updated", this, 3)([e]), e.has("showOnHover") && e.get("showOnHover") !== void 0) {
        var t = this.referenceElement,
          s = this._popoverRef.value;
        s && (this.removeAllTrackedEventListeners(t), this.removeAllTrackedEventListeners(s), this.removeAllTrackedEventListeners(document), this.showOnHover ? this._addShowOnHoverEvents(t, s) : this._addShowOnClickEvents(t, s));
      }
    }
  }, {
    key: "referenceElement",
    get: function get() {
      var _document$querySelect;
      var e = document.querySelector("#".concat(this.referenceId));
      return e || (e = (_document$querySelect = document.querySelector("[data-id=\"".concat(this.referenceId, "\"]"))) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.shadowRoot) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector("#".concat(this.referenceId))), e;
    }
  }, {
    key: "_addShowOnHoverEvents",
    value: function _addShowOnHoverEvents(e, t) {
      var _this2 = this;
      this.addTrackedEventListener(e, "mouseenter", function () {
        return _this2.showPopover();
      }), this.addTrackedEventListener(e, "mouseleave", function (s) {
        return _this2._handleMouseLeave(s, e, t);
      }), this.addTrackedEventListener(e, "click", function () {
        return _this2.showPopover(!0);
      }), this.addTrackedEventListener(t, "mouseenter", function () {
        return _this2.showPopover();
      }), this.addTrackedEventListener(t, "mouseleave", function (s) {
        if (_this2._mousedInsidePopover) {
          _this2.hidePopover();
          return;
        }
        _this2._handleMouseLeave(s, e, t);
      });
    }
  }, {
    key: "_addShowOnClickEvents",
    value: function _addShowOnClickEvents(e, t) {
      var _this3 = this;
      this.addTrackedEventListener(e, "click", function () {
        return _this3.showPopover();
      }), this.addTrackedEventListener(document, "click", function (s) {
        var o = t.getBoundingClientRect(),
          i = s.target === e;
        !(_this3._isMouseInside(s, o, 25) || _this3._hasPopoverAsParent(s.target)) && !i && _this3.hidePopover();
      });
    }
  }, {
    key: "_hasPopoverAsParent",
    value: function _hasPopoverAsParent(e) {
      var t = e === null || e === void 0 ? void 0 : e.parentElement;
      for (; t && t.tagName.toLowerCase() !== "ngc-popover";) {
        var _t;
        t = (_t = t) === null || _t === void 0 ? void 0 : _t.parentElement;
      }
      return !!t;
    }
  }, {
    key: "addTrackedEventListener",
    value: function addTrackedEventListener(e, t, s) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this.elementListeners.has(e) || this.elementListeners.set(e, []), this.elementListeners.get(e).push({
        eventType: t,
        listener: s,
        options: o
      }), e.addEventListener(t, s, o);
    }
  }, {
    key: "removeAllTrackedEventListeners",
    value: function removeAllTrackedEventListeners(e) {
      if (!this.elementListeners.has(e)) return;
      var t = this.elementListeners.get(e);
      var _iterator = _createForOfIteratorHelper(t),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref = _step.value;
          var s = _ref.eventType;
          var o = _ref.listener;
          var i = _ref.options;
          e.removeEventListener(s, o, i);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.elementListeners.delete(e);
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave(e, t, s) {
      var o = t.getBoundingClientRect(),
        i = s.getBoundingClientRect(),
        h = this._isMouseInside(e, o, -5),
        l = this._isMouseInside(e, i, 25);
      !h && !l && this.hidePopover(), l && (this._mousedInsidePopover = !0);
    }
  }, {
    key: "_isMouseInside",
    value: function _isMouseInside(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var o = t.left,
        i = t.right,
        h = t.top,
        l = t.bottom,
        c = e.clientX,
        f = e.clientY;
      return c >= o - s && c <= i + s && f >= h - s && f <= l + s;
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      var _t$shadowRoot;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.assignPosition();
      var t = this.referenceElement,
        s = this._popoverRef.value;
      s && (s.style.visibility = "visible", s.style.opacity = "1"), t && (_t$shadowRoot = t.shadowRoot) !== null && _t$shadowRoot !== void 0 && (_t$shadowRoot = _t$shadowRoot.firstElementChild) !== null && _t$shadowRoot !== void 0 && _t$shadowRoot.setAttribute("aria-expanded", "true"), this._focusFirstElement(e);
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var _this$referenceElemen;
      this._forceOpen || (this._popoverRef.value && (this._popoverRef.value.style.visibility = "hidden", this._popoverRef.value.style.opacity = "0"), this.referenceElement && ((_this$referenceElemen = this.referenceElement.shadowRoot) === null || _this$referenceElemen === void 0 || (_this$referenceElemen = _this$referenceElemen.firstElementChild) === null || _this$referenceElemen === void 0 ? void 0 : _this$referenceElemen.setAttribute("aria-expanded", "false")));
    }
  }, {
    key: "_getKeyboardFocusableElements",
    value: function _getKeyboardFocusableElements() {
      var _this$shadowRoot;
      var e = [];
      var t = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('slot[name="footer"]');
      if (this.shadowRoot && (e = e.concat(v(this.shadowRoot))), t) {
        var s = Array.from(t.assignedElements());
        for (var _i = 0, _s = s; _i < _s.length; _i++) {
          var o = _s[_i];
          e = e.concat(v(o));
        }
      }
      return e.filter(function (s) {
        return !s.hasAttribute("disabled") && !s.hasAttribute("aria-hidden");
      });
    }
  }, {
    key: "_focusFirstElement",
    value: function _focusFirstElement() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this._getKeyboardFocusableElements();
      if (t.length > 0) {
        var s = t[0];
        requestAnimationFrame(function () {
          var _s$shadowRoot, _o, _o2;
          var o;
          e ? o = s : (o = (_s$shadowRoot = s.shadowRoot) === null || _s$shadowRoot === void 0 ? void 0 : _s$shadowRoot.firstElementChild, (_o = o) === null || _o === void 0 ? void 0 : _o.classList.add("no-focus-visible")), (_o2 = o) === null || _o2 === void 0 ? void 0 : _o2.focus();
        });
      }
    }
  }, {
    key: "assignPosition",
    value: function assignPosition() {}
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._cleanup && this._cleanup(), _superPropGet(a, "disconnectedCallback", this, 3)([]);
    }
  }]);
}(E);
n([r({
  attribute: "reference-id"
})], a.prototype, "referenceId");
n([r({
  type: String
})], a.prototype, "title");
n([r()], a.prototype, "placement");
n([r({
  type: Number,
  attribute: "x-offset"
})], a.prototype, "xOffset");
n([r({
  type: Number,
  attribute: "y-offset"
})], a.prototype, "yOffset");
n([r({
  type: String,
  attribute: "icon-name"
})], a.prototype, "iconName");
n([r({
  type: String,
  attribute: "error-text"
})], a.prototype, "errorText");
n([r()], a.prototype, "size");
n([r({
  type: Boolean,
  attribute: "show-on-hover"
})], a.prototype, "showOnHover");
export { a as NjcPopover };